var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: {
        confirmMessage: "Upload",
        closeEnabled: !_vm.uploading || _vm.indexing,
        confirmEnabled: _vm.canUpload,
      },
      on: {
        confirm: _vm.upload,
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _vm._v("Upload new data to corpus "),
              _c("em", [_vm._v(_vm._s(_vm.corpus.displayName))]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("p", [_vm._v("You may upload:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("Normal files to be indexed")]),
        _vm._v(" "),
        _c("li", [
          _c("em", [_vm._v(".zip")]),
          _vm._v(" or "),
          _c("em", [_vm._v(".tar.gz")]),
          _vm._v(
            " archives containing multiple files at once.\n\t\t\tArchives should not contain files that cannot be indexed!\n\t\t"
          ),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("External metadata files separately")]),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "10px 25px 0px" } }, [
        !_vm.uploading
          ? _c("form", [
              _c(
                "label",
                {
                  staticClass:
                    "btn btn-info file-input-button document-upload-button",
                  attrs: { for: "data[]" },
                },
                [
                  _c("span", { staticClass: "document-upload-button-text" }, [
                    _vm._v(_vm._s(_vm.fileLabel)),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "file", name: "data[]", multiple: "" },
                    on: {
                      change: function ($event) {
                        _vm.documentFiles = $event.target.files
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "btn btn-default file-input-button document-upload-button",
                  attrs: { for: "linkeddata[]" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "document-upload-button-text",
                      attrs: { id: "upload-metadata-label" },
                    },
                    [_vm._v(_vm._s(_vm.metadataFileLabel))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "file", name: "linkeddata[]", multiple: "" },
                    on: {
                      change: function ($event) {
                        _vm.metadataFiles = $event.target.files
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "small",
                {
                  staticClass: "text-muted",
                  staticStyle: {
                    display: "block",
                    margin: "12px 0px",
                    width: "100%",
                  },
                  attrs: { id: "uploadFormatDescription" },
                },
                [
                  _vm._v("\n\t\t\t\tThe corpus accepts the following files:"),
                  _c("br"),
                  _vm._v(" "),
                  _vm.format
                    ? [_vm._v(_vm._s(_vm.format.description))]
                    : [
                        _vm._v(
                          "Unknown format (it may have been deleted from the server), uploads might fail"
                        ),
                      ],
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.uploading
          ? _c("div", { staticClass: "progress" }, [
              _c(
                "div",
                {
                  class: `progress-bar progress-bar-info progress-bar-striped ${
                    _vm.indexing ? "indexing" : ""
                  }`,
                  style: `width: ${_vm.uploadProgress}%;`,
                  attrs: {
                    id: "uploadProgress",
                    role: "progressbar",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    "aria-valuenow": _vm.uploadProgress,
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.indexing
                        ? _vm.indexProgressMessage
                        : _vm.uploadProgressMessage
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.uploadError
          ? _c("div", { staticClass: "alert alert-danger" }, [
              _vm._v(_vm._s(_vm.uploadError)),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }